import reportFailedRequest from "../service/error";

const STATUS_FULFILLED = "fulfilled";
const STATUS_REJECTED = "rejected";

export const allSettledReported = async (promises, file = "", req = null) => {
    const promiseAllResponse = await promiseAll(promises);

    let response = [];

    promiseAllResponse.map((r, key) => {
        if (r.status === STATUS_FULFILLED) {
            response.push(r.value);
        } else {
            response.push(null);

            reportFailedRequest(r.reason, req, file);
        }
    });

    return response;
};

export const allSettled = async (promises) => {
    const promiseAllResponse = await promiseAll(promises);

    let response = [];

    promiseAllResponse.map((r, key) => {
        if (r.status === STATUS_FULFILLED) {
            response.push(r.value);
        } else {
            response.push(null);
        }
    });

    return response;
};

const promiseAll = async (promises) => {
    return await Promise.all(
        promises.map((p) =>
            Promise.resolve(p).then(
                (val) => ({ status: STATUS_FULFILLED, value: val }),
                (err) => ({ status: STATUS_REJECTED, reason: err })
            )
        )
    );
};
